export default __webpack_public_path__ + "static/media/ProLawnMowMobile.294eab8a.jpg";